import { styled } from 'styled-components';

export const List = styled.ul`
  align-items: center;
  background-color: var(--color-background);
  border: var(--border-dark);
  border-radius: var(--border-radius-huge);
  color: var(--color-icons-inactive);
  display: flex;
  gap: var(--spacing-tiny);
  justify-content: center;
  padding: var(--spacing-tiny);
`;
